import { combineReducers } from 'redux';

import user from './user';
import popup from './popup';
import i18n from './i18nReducer';
import keycloak from './keycloak';
import creditCard from './creditCard';
import booking from './booking';
import brand from './brand';
import customFields from './customFields';
import formMirror from './formMirror';
import searchBookings from './searchBookings';
import impersonate from './impersonate';

export default combineReducers({
  user,
  popup,
  i18n,
  creditCard,
  booking,
  brand,
  customFields,
  formMirror,
  searchBookings,
  keycloak,
  impersonate
});
